import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';

import { MediaImageModel } from '@modules/media/models/media-image.model';
import { MediaVideoModel } from '@modules/media/models/media-video.model';

import { CarouselSectionComponent } from '../../slider/carousel-section/carousel-section.component';
import { AgendaSectionComponent } from '../agenda-section/agenda-section.component';
import { AnnouncementBannerComponent } from '../announcement-banner/announcement-banner.component';
import { ContactSectionComponent } from '../contact-section/contact-section.component';
import { DynamicSectionComponent } from '../dynamic-section/dynamic-section.component';
import { SectionType } from '../enums/section-type.enum';
import { Equal3SectionComponent } from '../equal3-section/equal3-section.component';
import { Equal4SectionComponent } from '../equal4-section/equal4-section.component';
import { EventPresentersSectionComponent } from '../event-presenter-section/event-presenter-section.component';
import { EventRegistrationSectionComponent } from '../event-registration-section/event-registration-section.component';
import { EventRibbonSectionComponent } from '../event-ribbon-section/event-ribbon-section.component';
import { HeroSectionComponent } from '../hero-section/hero-section.component';
import { HighlightSectionComponent } from '../highlight-section/highlight-section.component';
import { InfoSectionComponent } from '../info-section/info-section.component';
import { PressKitSectionComponent } from '../press-kit-section/press-kit-section.component';
import { PressReleaseSectionComponent } from '../press-release-section/press-release-section.component';
import { SectionHeadlineComponent } from '../section-headline/section-headline.component';
import { SquareSectionComponent } from '../square-section/square-section.component';
import { StageSectionComponent } from '../stage-section/stage-section.component';
import { StaggeredSectionComponent } from '../staggered-section/staggered-section.component';
import { TestCarSectionComponent } from '../test-car-section/test-car-section.component';
import { TestRouteSectionComponent } from '../test-route-section/test-route-section.component';

@Component({
  selector: 'mb-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SectionHeadlineComponent,
    NgClass,
    StageSectionComponent,
    AnnouncementBannerComponent,
    HeroSectionComponent,
    Equal3SectionComponent,
    Equal4SectionComponent,
    PressKitSectionComponent,
    PressReleaseSectionComponent,
    SquareSectionComponent,
    InfoSectionComponent,
    StaggeredSectionComponent,
    ContactSectionComponent,
    CarouselSectionComponent,
    EventRibbonSectionComponent,
    TestCarSectionComponent,
    AgendaSectionComponent,
    TestRouteSectionComponent,
    EventRegistrationSectionComponent,
    EventPresentersSectionComponent,
    HighlightSectionComponent,
    DynamicSectionComponent,
  ],
})
export class SectionComponent implements OnInit {
  private elRef = inject(ElementRef);

  @HostBinding('class.show')
  @Input()
  show = true;

  @Input() index!: number;
  @Input() data: any;

  @Output() openMedia = new EventEmitter<MediaImageModel | MediaVideoModel>();

  public teaserSectionType = SectionType;
  public sectionHeadlineClasses = ['header-inline'];

  ngOnInit(): void {
    if (this.data?.type) {
      this.elRef.nativeElement.classList.add(`section-type-${this.data.type}`);
    }

    if (!this.data?.headline && this.data?.anchor) {
      this.sectionHeadlineClasses.push('header-without-headline');
    }
  }
}
